// TODO move to formatters or normalize
export const transformContractAccountId = (contractAccountId: string): string =>
  `${contractAccountId
    .replace(/[^0-9]/g, '') // Remove non numerical characters
    .substring(0, 12) // a maximum of 12 characters
    .replace(/(.{3})/g, '$1 ')}` // add a space after ever third character
    .trim(); // remove any trailing spaces if they we're added by the previous line

export const transformKrakenId = (accountId: string): string =>
  accountId
    .toUpperCase()
    .replace(/[^\dA-Z-]/g, '') // remove anything that isn't numbers, letters or hyphens
    .replace(/^A(\w)/, 'A-$1') // formats for A123 -> A-123
    .substring(0, 10); // a maximum of 10 characters

export const transformAccountId = (accountId: string): string => {
  const firstChar = accountId.charAt(0);

  if (/\d/.test(firstChar)) {
    return transformContractAccountId(accountId);
  }

  if (/[aA]/.test(firstChar)) {
    return transformKrakenId(accountId);
  }

  return '';
};
